import { gql } from "@apollo/client";
export const conditioningDataQry = gql`
{
    conditionnings{
        id
        value
    }
    otherProducts{
        id
        name
        group
    }
}
`;
